<ui-transaction-items [queueId]="queueId$ | async"
                      [isReviewMode]="false">
</ui-transaction-items>
